var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopmentType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0832 21.9999H3.65415C2.21415 21.9999 1.04688 20.695 1.04688 19.0853C1.04688 17.4755 2.21415 16.1707 3.65415 16.1707H14.0941C15.5341 16.1707 16.7014 17.4755 16.7014 19.0853C16.7014 20.695 15.5341 21.9999 14.0832 21.9999Z",
    stroke: "#55489E",
    strokeWidth: 1.913,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04688 9.17065H13.5705L16.7014 12.6706V16.1706H4.17778L1.04688 12.6706V9.17065Z",
    stroke: "#55489E",
    strokeWidth: 1.913,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9994 22.0001H19.8321C18.1084 22.0001 16.7012 20.4392 16.7012 18.5001V12.6709H18.7848L23.9994 19.6709V22.0001Z",
    stroke: "#55489E",
    strokeWidth: 1.913,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4403 9.1707H2.08398V1H8.3458L10.4403 9.1707Z",
    stroke: "#55489E",
    strokeWidth: 1.913,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H11.4764",
    stroke: "#55489E",
    strokeWidth: 1.913,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6539 4.50024C14.4976 4.50024 13.5703 5.54902 13.5703 6.8295V9.15876",
    stroke: "#55489E",
    strokeWidth: 1.913,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentType);
export default __webpack_public_path__ + "static/media/development-type.5c7ceea0.svg";
export { ForwardRef as ReactComponent };